module.exports = __webpack_public_path__ + "static/img/androidDownload.95bc0386.png";